"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalColumn = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const utils_1 = require("../../utils");
const atoms_1 = require("../atoms");
const ExternalColumnLink_1 = require("./ExternalColumnLink");
const Styled = styled_components_1.default.section `
	.h3 {
		display: inline-block;
	}
	.h4 {
		margin: 24px 0 0 0;
	}
	p {
		padding: 0;
		margin: 4px 0 0 0;
	}
	&& {
		a.external-link {
			padding: 16px 0 0 0;
			max-width: 231px;
			display: block;
			&:hover {
				.arrow-wrap {
					transform: translate3d(0, 0, 0) translateX(1px) translateY(-1px);
				}
			}
		}
	}
`;
const ExternalColumn = (props) => {
    const isValid = (0, utils_1.isValidExternalColumn)(props);
    if (!isValid)
        return null;
    const { eyebrow, links = [] } = props;
    return (react_1.default.createElement(Styled, { className: "external" },
        eyebrow && react_1.default.createElement(atoms_1.Heading4, null, eyebrow),
        links.map((link) => {
            if (!link)
                return;
            return react_1.default.createElement(ExternalColumnLink_1.ExternalColumnLink, { key: link.key || link.title, link: link, locale: props.locale });
        })));
};
exports.ExternalColumn = ExternalColumn;
//# sourceMappingURL=ExternalColumn.js.map